type IssueTicket = {
  idNumber: number;
};

export const formatIssueTicketId = (
  issueTicket: IssueTicket,
  withPrefix: boolean = true,
) => {
  const id = issueTicket.idNumber.toString().padStart(4, '0');

  return withPrefix ? `ID${id}` : id;
};
